import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllContracts = () => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.contracts,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchContractsPerProfile = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.contractsPerProfile(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchContractsPerBusiness = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.contractsPerBusiness(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchContractDetails = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.updateContract(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const validateRecipientData = (data) =>
  data?.recipientName !== "" &&
  data?.recipientRole !== "" &&
  data?.recipientEmail !== "";

export const createContract = (data, base64, businessData, signers) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.createContract,
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      contractbusinessid: businessData?.id,
      originalcontractbase64: base64,
      contractname: data?.name,
      contracttype: parseInt(data?.type),
      expirationDate: new Date(data?.expiryDate).toISOString(),
      signers: [
        // {
        //     "language": data?.language,
        //     "id": businessData?.accepted_offer_parties?.buyeruserid,
        // },
        // {
        //     "language": data?.language,
        //     "id": businessData?.accepted_offer_parties?.selleruserid
        // },
        ...(signers?.length > 0
          ? signers.map((item) => ({
              name: item?.name,
              email: item?.email,
              language: data?.language,
            }))
          : []),
      ],
      recipents: validateRecipientData(data)
        ? [
            {
              name: data?.recipientName,
              role: data?.recipientRole,
              email: data?.recipientEmail,
            },
          ]
        : [],
    },
  });
};

export const sendContractReminder = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.contractReminder(id),
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
